(function ($) {
  var $toolbar = $('.toolbar');
  var opened = false;

  function open() {
    if (!opened) {
      $toolbar.addClass('toolbar--open');
      opened = true;
    }
  }

  function close() {
    if (opened) {
      $toolbar.removeClass('toolbar--open');
      $toolbar.removeClass('toolbar--newsletter');
      $toolbar.removeClass('toolbar--country');
      opened = false;
    }
  }

  $('.js-toolbar__newsletter').click(function (event) {
    if (
      $toolbar.hasClass('toolbar--newsletter') &&
      $toolbar.hasClass('toolbar--open')
    ) {
      close();
    } else {
      open();
      $toolbar.addClass('toolbar--newsletter');
    }
    $toolbar.removeClass('toolbar--country');
  });

  $('.js-toolbar__country').click(function (event) {
    if (
      $toolbar.hasClass('toolbar--country') &&
      $toolbar.hasClass('toolbar--open')
    ) {
      close();
    } else {
      open();
      $toolbar.addClass('toolbar--country');
    }
    $toolbar.removeClass('toolbar--newsletter');
  });

  // Close if clicked outside toolbar
  $('body').click(function (ev) {
    if (!$(ev.target).closest('.toolbar__panel').length) {
      close();
    }
  });

  // Close when scrolled
  $(window).scroll(close);
})(jQuery);
